import $x from '@/utils/$x';

// 获取用户分布数据
export const fetchDistributionData = async (territory = '', region = '', filterAvailableTenantMembers = true) => {
  const requestData = {
    filterAvailableTenantMembers
  };
  if (territory) {
    requestData.territory = territory;
  }
  if (region) {
    requestData.region = region;
  }
  
  return $x.post('/territory/distribution/stats', {
    requestData
  });
};

// 获取教练分布数据
export const fetchCoachDistributionData = async (territory = '', region = '') => {
  const requestData = {};
  if (territory) {
    requestData.territory = territory;
  }
  if (region) {
    requestData.region = region;
  }
  
  return $x.post('/territory/distribution/coach', {
    requestData
  });
};